import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { shouldUseAnchorForLink } from "@faire/web--source/ui/lib";
import { Anchor, Link } from "@faire/web--source/ui/LinkAnchor";
import { useHistory } from "react-router-dom";
export var useGetAttributes = function(props) {
    var linkTo = props.linkTo;
    var history = useHistory();
    if (linkTo === undefined) {
        return {
            as: "button",
            linkProps: {}
        };
    }
    if ("download" in props || shouldUseAnchorForLink(linkTo)) {
        var descriptor = typeof linkTo === "function" ? linkTo(history.location) : linkTo;
        var resolved = typeof descriptor === "string" ? descriptor : history.createHref(descriptor);
        return {
            as: Anchor,
            linkProps: {
                href: resolved
            }
        };
    }
    return {
        as: Link,
        linkProps: {
            to: linkTo,
            replace: props.replace
        }
    };
};
export var extendBaseThemeVariant = function(baseTheme, extendedTheme) {
    return function(props) {
        var baseThemeComputed = typeof baseTheme === "function" ? baseTheme(props) : baseTheme;
        var extendedThemeComputed = typeof extendedTheme === "function" ? extendedTheme(props) : extendedTheme;
        return _object_spread({}, baseThemeComputed, extendedThemeComputed);
    };
};
